import { ConfigManager } from '../../../application/config/ConfigManager';
import { IConfig } from '../../../application/config/IConfig';
import { getCurrentCsrfCookie } from '../../../application/csrfProtection/getCurrentCsrfCookie';
import { CRUDServiceType } from '../../common/service/CRUDServiceType';
import wretch from 'wretch';

export class AnalyticsDataService {
  protected config: IConfig = ConfigManager.getConfig()

  constructor(
    private type: CRUDServiceType
  ) {
  }

  async getApplicationRequirementsData(applicationId) {
    const url = `${this.getEndpoint()}/applicationRequirementsData/${applicationId}`;
    return await this.request()
      .url(url)
      .get()
      .json()
      .catch(this.handleError);
  }

  async getApplicationVendorData(applicationId) {
    const url = `${this.getEndpoint()}/applicationVendorData/${applicationId}`;
    return await this.request()
      .url(url)
      .get()
      .json()
      .catch(this.handleError);
  }

  getEndpoint(): string {
    const url = this.config.url.api[this.type];
    return `${url}/analytics`;
  }

  handleError = (errorResponse: any) => {
    return errorResponse;
  };

  protected request() {
    return wretch()
      .options({
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': `${getCurrentCsrfCookie()}`,
        },
        credentials: 'include',
      })
      .errorType('json');
  }
}
